<template>
    <div style="height:100%">
        <!-- 订单内容区开始 -->
        <el-breadcrumb
            separator-class="el-icon-arrow-right"
            style="margin-bottom:10px"
        >
            <el-breadcrumb-item>订单</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="display:flex;flex-direction: row ">
            <el-input
                class="search_input"
                v-on:input="inputkeyword"
                placeholder="请输入用户昵称、微信单号、套餐名称或景区进行搜索"
                clearable
                v-model="listQuery.key_value"
            ></el-input>
            <!-- 根据分享人进行搜索 -->
            <div style="width:350px;margin-left:15px">
                <el-input
                    placeholder="请输入分享人进行搜索"
                    v-model="listQuery.nick_name"
                    @clear="clearSharer"
                    clearable
                >
                    <el-button
                        slot="append"
                        icon="el-icon-search"
                        @click="searchOrders"
                    ></el-button>
                </el-input>
            </div>
            <el-select v-model="listQuery.is_note" clearable style="width: 150px;margin-left:15px;" class="filter-item" placeholder="订单类型" @change="searchOrders">
                <el-option value="0" label="普通订单"/>
                <el-option value="1" label="服务码订单"/>
            </el-select>
            <el-select v-model="listQuery.is_used" clearable style="width: 200px;margin-left:15px;" class="filter-item" placeholder="请选择服务码使用状态" @change="searchOrders">
                <el-option value="0" label="未使用"/>
                <el-option value="1" label="已使用"/>
            </el-select>
        </div>

        <el-table :data="orders" style="width: 100%">
            <el-table-column prop="nick_name" label="昵称"> </el-table-column>
            <el-table-column prop="wx_phone" label="手机号"> </el-table-column>
            <el-table-column prop="cost" label="金额"> </el-table-column>
            <el-table-column prop="code" label="服务码"> </el-table-column>
            <el-table-column align="center" label="服务码使用状态" prop="is_used">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.code">{{ scope.row.is_used == 1 ? '已使用' : '未使用' }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="gmttime" label="购买时间"> </el-table-column>
            <el-table-column prop="out_trade_no" label="微信单号">
            </el-table-column>
            <el-table-column prop="share_name" label="分享人" width="150px">
            </el-table-column>
            <el-table-column prop="area_name" label="购买景区">
            </el-table-column>
        </el-table>
        <!-- 分页区 -->
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="listQuery.pageindex"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="listQuery.pagesize"
            layout="total,  prev, pager, next, jumper"
            :total="total"
            style="text-align:right;margin:0 16px 10px 0;border-radius:20px"
        >
        </el-pagination>
    </div>
</template>

<script>
import qs from "qs";
let input_timer;
export default {
    data() {
        return {
            total: 0,
            orders: [],
            listQuery: {
                pageindex: 1,
                pagesize: 10,
                key_value: undefined,
                nick_name: undefined,
                is_used: undefined,
                is_note: undefined,
                orderby: 'gmttime desc',
                count: false,
            },
        };
    },
    mounted() {
        this.getOrders();
    },
    methods: {
        //查询订单
        getOrders() {
            if (this.listQuery.pageindex == 1) {
                this.listQuery.count = true;
            }
            this.$axios
                .postRequest({
                    methodUrl: "wechat/getOrderInfo",
                    jsonParam: qs.stringify(this.listQuery)
                })
                .then(
                    res => {
                        //成功之后处理逻辑
                        if (this.listQuery.pageindex == 1) {
                            this.total = res.data.totalcount;
                        }
                        this.orders = res.data.list;
                    },
                    function(error) {
                        //失败之后处理逻辑
                        console.log(error);
                    }
                );
        },
        searchOrders() {
            this.listQuery.pageindex = 1;
            this.getOrders()
        },
        clearSharer() {
            this.listQuery.pageindex = 1;
            this.getOrders();
        },
        //分页
        handleSizeChange(val) {
            this.listQuery.pagesize = val;
            this.getOrders();
        },
        handleCurrentChange(val) {
            this.listQuery.pageindex = val;
            this.getOrders();
        },
        inputkeyword() {
            if (input_timer) {
                clearTimeout(input_timer);
            }
            input_timer = setTimeout(() => {
                this.listQuery.pageindex = 1;
                this.getOrders();
            }, 500);
        }
    }
};
</script>

<style>
.scroll::-webkit-scrollbar {
    display: none;
}
.search_input {
    width: 25em !important;
    margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/storeManagementList/order.vue